const firstAndLastDoubleQuote = /^"|"$/g;

type UnpackErrorResult = { message: string };

// TODO: move to utils when all rtk queries use the same error handling
export const unpackError = (error: unknown): UnpackErrorResult => {
    const err = error as { response?: { data?: Record<string, unknown> }; request?: { response?: string } };

    if (err?.response?.data?.message && typeof err.response.data.message === "string") {
        return { message: err.response.data.message };
    }

    if (err?.response?.data?.ErrorMessage && typeof err.response.data.ErrorMessage === "string") {
        return { message: err.response.data.ErrorMessage };
    }

    if (err?.response?.data?.error_description && typeof err.response.data.error_description === "string") {
        return { message: err.response.data.error_description };
    }

    if (typeof err?.request?.response === "string") {
        return {
            message: err.request.response.replace(firstAndLastDoubleQuote, ""),
        };
    }

    return { message: error instanceof Error ? error.message : "An error occurred" };
};
